import { z } from "zod";

export const genderSchema = z.enum(["male", "female", "other"]);
export const profileVisibilitySchema = z.enum(["public", "private"]);

export type OnboardingFormFieldName =
	| "name"
	| "dateOfBirth"
	| "gender"
	| "privacyConsent";

export type OnboardingFormValues = {
	name: string;
	dateOfBirth: string;
	gender: "" | z.infer<typeof genderSchema>;
	privacyConsent: boolean;
};

export type OnboardingValidationErrors = Partial<
	Record<OnboardingFormFieldName, string>
>;

export const DEFAULT_ONBOARDING_VALUES: OnboardingFormValues = {
	name: "",
	dateOfBirth: "",
	gender: "",
	privacyConsent: false,
};
